/* imports here get imported by initialize.js and included in the everfi-sdk.js bundle */
import 'views/block/base-block-view';
import 'views/block/multimedia-block-view';
